import { createSlice } from "@reduxjs/toolkit";

const staffSlice = createSlice({
  name: "staff",
  initialState: {
    staffList: [],
    staffAllList: [],
    isFetching: false,
    isLoggedIn: false,
    error: false,
    totalPage: 0,
    totalItem: 0,
  },
  reducers: {
    getStaff: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getStaffSuccess: (state, action) => {
      state.isFetching = false;
      state.staffList = action.payload.data
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    getStaffFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    getAllStaff: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getAllStaffSuccess: (state, action) => {
      state.isFetching = false;
      state.staffAllList = action.payload.data
      state.error = false;
    },
    getAllStaffFailed: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    addStaff: (state) => {
      state.isFetching = true
      state.error = false
    },
    addStaffSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    addStaffFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
    updateStaff: (state) => {
      state.isFetching = true
      state.error = false
    },
    updateStaffSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    updateStaffFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
    removeStaff: (state) => {
      state.isFetching = true
      state.error = false
    },
    removeStaffSuccess: (state) => {
      state.isFetching = false
      state.error = false
    },
    removeStaffFailed: (state) => {
      state.isFetching = false
      state.error = true
    },
  },
});

export const staffActions = staffSlice.actions;
export default staffSlice.reducer;
